<div class="gen-dialog-holder">
    <div class="right-sub-section-holder">
        <div class="icon-link-data"></div>
        <p>
            {{translationService.translate('reportWizard')}}
        </p>
    </div>

    <h1>{{translationService.translate(dialogData.title)}}</h1>
    <h2 *ngIf="parameterData && parameterData.length > 0">{{translationService.translate('reportData')}}</h2>

    <div>

        <div *ngFor="let dataItem of parameterData">
            <div [ngSwitch]="dataItem.DataType" *ngIf="!dataItem.IsAuto">

                <div class="input-holder">
                    <div class="form-group">

                        <div class="label-holder">
                            <label><span *ngIf="!dataItem.Nullable">*

                                </span>{{translationsService.translate(dataItem.Name)}}</label>
                        </div>

                        <div class="control-holder">

                            <sem-many-to-one *ngSwitchCase="'ManyToOne'" class='sem-many-to-one' name='onetomany'
                                [(ngModel)]='dataItem.Name' [(model)]='model' [entityName]="dataItem.Name" [showControls]="true"
                                [modelName]="dataItem.ModelName" [dialogTitle]="''" [displayFields]="[]" [searchFields]="[]" [entityFormUrl]="''" [entityReadOnly]="false" [readOnly]="false">
                            </sem-many-to-one>

                            <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" [form]="form" *ngSwitchCase="'String'" [(ngModel)]="model[dataItem.Name]"
                                [isReadOnly]="dataItem.IsReadOnly" name="{{dataItem.Name}}">
                            </sem-text-box>
                            <sem-text-box [isPasswordInput]="false" [isNumberInput]="true" [form]="form" *ngSwitchCase="'Integer'" [(ngModel)]="model[dataItem.Name]"
                                [isReadOnly]="dataItem.IsReadOnly" name="{{dataItem.Name}}">
                            </sem-text-box>

                            <sem-drop-down-select [form]="form" [filterField]="dataItem.FilterField"
                                [titleField]="dataItem.TitleField" [galregistryname]="dataItem.ModelName"
                                *ngSwitchCase="'Object'" [ngModel]="getProp(dataItem.Name)"
                                (ngModelChange)="setProp(dataItem.Name, $event)" name="{{dataItem.Name}}"
                                [multiFieldRootPropertyBinding]="''" [waitForFilteredValue]="false"
                                [filteredValueBinding]="''">
                            </sem-drop-down-select>

                            <sem-date-picker [form]="form" [ngModel]="getProp(dataItem.Name, dataItem.Expression)"
                                (ngModelChange)="setProp(dataItem.Name, $event)" *ngSwitchCase="'DateTime'"
                                name="{{dataItem.Name}}" date-format="DD/MM/YYYY" [templateType]="'calendar_month'"
                                [isReadOnly]="dataItem.IsReadOnly">
                            </sem-date-picker>

                            <sem-check-box [form]="form" *ngSwitchCase="'Bool'" [ngModel]="getProp(dataItem.Name)"
                                (ngModelChange)="setProp(dataItem.Name, $event)" name="{{dataItem.Name}}">
                            </sem-check-box>
                        </div>
                        <!--
                        <div class="error-message repeater-error" propertyName="propertyName"
                            *ngIf="form.submitted && checkForError(dataItem.Name)">
                            {{checkTranslation('galis_error_required')}}</div>
                        -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <button (click)="generate()" type="button">{{translationService.translate('generate')}}</button>

</div>